module.exports = __webpack_public_path__ + "img/url_icon.0f0e0ded.svg";